<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" ariaLabel="Envío de la notificación por correo">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">Envío de la notificación por correo</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        style="max-height: 40vh"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="selectRef">
              <label class="text-sm text-secondary-600 block mb-4">{{processMessage}}</label>
              
              <accessible-el-select
                prop="groupId"
                v-model="form.groupId"
                isMultiple
                group
                :options="listaGroupsGrouping.map(group => ({ 
                  label: group.label,
                  options: group.options.map(x => ({id: x.value, value: x.value, name: x.label }))
                }))"
                id-prefix="linkgroupsbyclientiddialog"
                :isDisabled="isLoadingSelect"
              >
                <template #label>
                  {{$t('app.groups')}}
                </template>
              </accessible-el-select>

            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button mode="secondary-phantom-blue"
          class="w-full"
          v-if="!isAllSelected" 
          :disabled="!isLoadedData || isLoadingSelect || isEmptyList" 
          :text="$t('app.select_all')" 
          @click="handleSelectAll" 
          :loading="isLoadingSelect || isGeneralLoading"
          />
        <base-button v-else :text="$t('app.unselect_all')" mode="secondary-phantom-blue"
          class="w-full"
          @click="handleUnSelectAll"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect || isEmptyList || isGeneralLoading"
          />
          <div class="w-48 "></div>
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
          class="w-full"
          :loading="isLoadingSelect || isGeneralLoading"
          :disabled="isLoadingSelect"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply" 
          :loading="isLoadingSelect || isGeneralLoading"
          :disabled="isLoadingSelect"/>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import { getMyGroups } from '@/services/configurations/groups/getMyGroups'
import { getGroupsSimple } from '@/services/configurations/groups/getGroupsSimple'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'link-my-groups-dialog',
  components: {
    BaseDialogButton,
    AccessibleElSelect,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    idCliente: {
      type: [Number, String],
      default: null
    },
    idNEO: {
      type: [Number, String],
      default: null
    },
    idRegla: {
      type: [Number, String],
      default: null
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      processMessage: 'Seleccione los grupos a los que desee añadir los correos a sus listas blancas de emails.',
      form: {
        groupId: []
      },
      groups: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      this.form.groupId = []
      this.groups = []
      if (value) this.downloadMyGroups()
    }
  },
  mounted: async function () {
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    listaGroupsGrouping () {
      if (!this.isEmptyList) {
        const options = []
        this.groups.forEach(x => {
          if (options.filter(y => y.label === x.group).length === 0) {
            options.push(
              { label: x.group, options: [] }
            )
          }
        })
        this.groups.forEach(x => {
          const index = options.map(x => x.label).indexOf(x.group)
          options[index].options.push(
            {
              value: x.id,
              label: x.value,
            }
          )
        })
        return options
      }
      return []
    },
    isEmptyList: function () {
      return this.groups === undefined || this.groups === null || this.groups.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.groups.length === this.form.groupId.length) return true
      else return false
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
  },
  methods: {
    downloadMyGroups: async function () {
      try {
        this.isLoadedData = false
        const params = { 
          idRegla: this.idRegla, 
          idNEO: this.idNEO,
          idCliente: this.idCliente,
        }
        let data
        if (this.idRegla) {
          data = await getGroupsSimple(params)
        } else {
          data = await getMyGroups(params)
        }
        if (data.blnError === true) {
          this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
        } else {
          data.Respuesta.forEach(row => {
            this.groups.push({ id: row.IdGrupo, value: row.Nombre, group: row.Tipo })
          })
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.isLoadedData = true
      }
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRef.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.groupId = []
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', this.form.groupId)
      this.form.groupId = []
    },
    handleSelectAll: async function () {
      // this.form.location = []
      await this.handleUnSelectAll()
      this.loadingActionSelect = true
      this.groups.forEach(element => {
        setTimeout(() => {
          this.form.groupId.push(element.id)
          if (this.form.groupId.length === this.groups.length) {
            this.loadingActionSelect = false
            this.loadingActionUnSelect = false
          }
        }, 100)
      })
    },
    handleUnSelectAll: async function () {
      this.loadingActionUnSelect = true
      const staticLength = this.form.groupId.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.form.groupId.pop()
          if (this.form.groupId.length === 0) this.loadingActionUnSelect = false
        }, 100)
      }
    }
  }
}
</script>
